<template>
  <mdb-container>
    <Errors v-if="!!error" :error="error" />
    <mdb-row>
      <mdb-col v-if="showSpinner">
        <Spinner />
      </mdb-col>
    </mdb-row>

    <mdb-alert
      color="dark"
      v-if="message"
      @closeAlert="message = false"
      dismiss
    >
      {{ message }}
    </mdb-alert>

    <form @submit.prevent="createAsset">
      <mdb-col col="12" class="pb-2 justify-content-md-center">
        <mdb-row>

          <mdb-col col="4">
            <mdb-input label="Asset Name" v-model="assetInfo.name" required />
          </mdb-col>

           <mdb-col col="4">
            <mdb-input label="Asset Type" v-model="assetInfo.asset_type" @change="validateAssetType" required />
          </mdb-col>

           <mdb-col col="4">
            <mdb-input label="Scan Key" placeholder="string key e.g. b for bags " v-model="assetInfo.scan_key" required />
          </mdb-col>
          <mdb-col col="4">
            <mdb-btn
              :disabled="!isDisabled"
              outline="primary"
              type="submit"
              :icon="btnInfo.btnIcon"
              >{{ btnInfo.btnName }}</mdb-btn
            >
          </mdb-col>
        </mdb-row>
      </mdb-col>
    </form>
  </mdb-container>
</template>

<script>
import api from "@/api";
import Errors from "@/components/Errors";
import Spinner from "@/components/Spinner";

import {
  mdbRow,
  mdbCol,
  mdbContainer,
  mdbBtn,
  mdbAlert,
  mdbInput,
} from "mdbvue";

export default {
  components: {
    Errors,
    mdbRow,
    mdbCol,
    mdbContainer,
    mdbBtn,
    mdbAlert,
    Spinner,
    mdbInput
  },

  data() {
    return {
      assetInfo: {},
      error: "",
      btnInfo: {},
      isLoading: true,
      message: "",
    };
  },
  methods: {
    newAsset() {
      return {
        name: "",
        asset_type: "",
        scan_key: "",
      };
    },
    createAsset() {
      api
        .createAsset(this.assetInfo)
        .then(() => {
          this.$emit("asset-created");
          this.reset();
        })
        .catch((error) => {
          this.error = error.response.data.errors.full_messages[0];
        });
    },
    reset() {
      this.assetInfo = this.newAsset();
      this.errors = {};
    },
    setBtnInfo() {
      return { btnName: "Create Asset", btnIcon: "plus" };
    },
    validateAssetType() {
       this.assetInfo.asset_type = this.assetInfo.asset_type.toLowerCase().replace(' ', '_');
    },
  },

  created() {
    this.assetInfo = this.newAsset();
    this.btnInfo = this.setBtnInfo();
    this.isLoading = false;
  },
  mounted() {},
  computed: {
    showSpinner() {
      return this.isLoading;
    },

    isDisabled() {
      return (
        !!this.assetInfo.name &&
        !!this.assetInfo.asset_type &&
        !!this.assetInfo.scan_key 
      );
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  color: $black-accent-color;
  border-color: $black-accent-color;
  text-transform: uppercase;

  &:hover {
    background-color: $green-accent-color;
    color: white;
  }
}
</style>
